<template>
  <div>
      <ob-modal2 :show.sync="show" :width="800" :backdrop="false">
          <template slot="modal-title">
                  Change Signatory Authority to Review and Sign Section 5&6
      </template>
      <div slot="modal-body">
        <p style="margin-bottom: 10px;color:#212121;"><strong>Current Employer Official with Signatory Authority:</strong></p>
       <div class="row" v-if="changeSAType == 'Employer'">
        <div  style="margin-bottom: 10px;">
          <div class="col-md-4">
            <p>Signatory Authority Name:</p>
            <!-- <p>Name</p> -->
             <span style="color:#212121"><strong>{{ content.Employer.SignatoryAuthority.Name ? content.Employer.SignatoryAuthority.Name : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Signatory Authority Email:</p>
            <span style="color:#212121"><strong>{{ content.Employer.SignatoryAuthority.Email ? content.Employer.SignatoryAuthority.Email : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Phone Number:</p>
            <span style="color:#212121"><strong>{{ content.Employer.SignatoryAuthority.Phone ? content.Employer.SignatoryAuthority.Phone : 'N/A' }} </strong></span>
          </div>          
        </div>
       </div>
       <div class="row" v-if="changeSAType == 'AssignedTraining'">
        <div  style="margin-bottom: 10px;">
          <div class="col-md-4">
            <p>Signatory Authority Name:</p>
            <!-- <p>Name</p> -->
             <span style="color:#212121"><strong>{{ content.AssignedTraining.SignatoryAuthority.Name ? content.AssignedTraining.SignatoryAuthority.Name : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Signatory Authority Email:</p>
            <span style="color:#212121"><strong>{{ content.AssignedTraining.SignatoryAuthority.Email ? content.AssignedTraining.SignatoryAuthority.Email : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Phone Number:</p>
            <span style="color:#212121"><strong>{{ content.AssignedTraining.SignatoryAuthority.Phone ? content.AssignedTraining.SignatoryAuthority.Phone : 'N/A' }} </strong></span>
            
          </div>
        </div>
       </div>
       <div class="row" v-if="changeSAType == 'Evaluation'">
        <div  style="margin-bottom: 10px;">
          <div class="col-md-4">
            <p>Signatory Authority Name:</p>
            <!-- <p>Name</p> -->
             <span style="color:#212121"><strong>{{ content.Evaluation.SignatoryAuthority.Name ? content.Evaluation.SignatoryAuthority.Name : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Signatory Authority Email:</p>
            <span style="color:#212121"><strong>{{ content.Evaluation.SignatoryAuthority.Email ? content.Evaluation.SignatoryAuthority.Email : 'N/A' }} </strong></span>
          </div>
          <div class="col-md-4">
            <p>Phone Number:</p>
            <span style="color:#212121"><strong>{{ content.Evaluation.SignatoryAuthority.Phone ? content.Evaluation.SignatoryAuthority.Phone : 'N/A' }} </strong></span>
            
          </div>
        </div>
       </div>
       <p v-if="changeSAType == 'Employer'" style="padding:10px 0;  color: #212121; white-space: nowrap; "> <strong>Who should review and sign the Employer Information (Section3 & 4) ?</strong></p>
       <p v-if="changeSAType == 'AssignedTraining'" style="padding:10px 0;  color: #212121; white-space: nowrap; "> <strong>Who should review and sign the Training Plan for STEM OPT students (Sections 5 & 6)?</strong></p>
       <p v-if="changeSAType == 'Evaluation'" style="padding:10px 0;  color: #212121; white-space: nowrap; "> <strong>Who should review and sign the Training Plan for Evaluation section</strong></p>
        <div class="row">
            <div class="col-md-5">
                <div class="form-group" >
                    <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span>
                    <ob-select2 v-if="showSignatoryauthorityList"  :options="signatoryauthorityList" v-model.trim="selectedSignatoryAuthorityEmail" :class="{ 'ob-vuelidate_input-error': $v.selectedSignatoryAuthorityEmail.$error }"></ob-select2>
                    <span style="display: block;" v-else>Loading....</span>
                    <span class="ob-vuelidate_error-msg" v-if="$v.selectedSignatoryAuthorityEmail.$dirty && !$v.selectedSignatoryAuthorityEmail.requiredIf" style="display: ruby-text">Select Employer Official with Signatory Authority</span>
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 pL0 pR0">
              <div class="col-md-4 pL0"  v-if="selectedSignatoryAuthorityEmail && selectedSignatoryAuthorityEmail != ''">
                  <div class="form-group" style="padding-left :17px;padding-top: 6px;">
                      <label>Signatory Authority Name</label>
                      <b><p>{{SignatoryAuthority.Name ? SignatoryAuthority.Name  : 'N/A'}}</p></b>
                  </div>
              </div>
              <div class="col-md-4"  v-if="selectedSignatoryAuthorityEmail && selectedSignatoryAuthorityEmail != ''">
                  <div class="form-group" style="padding-top: 6px;">
                      <label>Signatory Authority Email</label>
                    <b><p> {{SignatoryAuthority.Email ?SignatoryAuthority.Email : 'N/A' }}</p></b>
                  </div>
              </div>
              <div class="col-md-4"  v-if="selectedSignatoryAuthorityEmail && selectedSignatoryAuthorityEmail != ''">
                  <div class="form-group" style="padding-top: 6px;">
                      <label>Signatory Authority Title</label>
                    <b><p> {{SignatoryAuthority.Title ? SignatoryAuthority.Title : 'N/A' }}</p></b>
                  </div>
              </div>
            </div>
        </div>
        <div class="note mt-3" v-if="SignatoryAuthority.Email && SignatoryAuthority.Email != '' && SignatoryAuthority.Email != loggedInUserObj.email">
          <p class="text-info" v-if="changeSAType == 'AssignedTraining'">
            Note: An email will be sent to <strong>{{ SignatoryAuthority.Email }}</strong> to review and sign Sections 5 & 6 once the employee reviews the training plan.
          </p>
          <p class="text-info" v-if="changeSAType == 'Evaluation'">
            Note: An email will be sent to <strong>{{ SignatoryAuthority.Email}}</strong> to review and sign Evaluation once the employee reviews the Evaluation.
          </p>
          <p class="text-info" v-if="changeSAType == 'Employer'">
            Note: An email will be sent to <strong>{{ SignatoryAuthority.Email }}</strong> to review and sign Sections 3 & 4 
          </p>
        </div>
      </div>
      <div slot="modal-footer">
        <ob-button type="secondary" @click="close">Cancel</ob-button>
        <ob-button type="primary" @click="changeAuthority">Change</ob-button>
      </div>
    </ob-modal2>
  </div>
</template>

  

<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      show: false,
      selectedAuthority: null,
      signatoryauthorityList: {
              placeholder: {
                  id: "-1",
                  text: "Select Signatory Authority"
              },
              data: []
      },
      SignatoryAuthority : {
        Name: '',
        Email:'',
        Title:'',
        Phone: '',
        Role:''
      }, 
      showSignatoryauthorityList:false,
      selectedSignatoryAuthorityEmail:'',
    };
  },
  props:["openModal", "content","changeSAType"],
  watch:{
      openModal(val){
      if(val){
        this.show=val;
        this.getSignatoryauthorityList();
      }
  },
  selectedSignatoryAuthorityEmail(v) {
               this.onChangeSignatoryAuthority(v);
           },
 
  show(val) {
    if(!val) {
      this.$emit('update:openModal', val)
    }
  }
    },
    validations() {
    return {
      "selectedSignatoryAuthorityEmail":{
          requiredIf: requiredIf((a) => {
                      if(this.content.Employer.SectionStatus != 'Completed') {
                          return true
                      }else{
                          return false
                      }
                  })
          },
    }
  },
  methods: {
    SignatoryChange() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.SignatoryAuthority.Email = ''
      this.SignatoryAuthority.Name = ''
      this.SignatoryAuthority.Title = ''
      this.selectedSignatoryAuthorityEmail = ''
      this.$v.selectedSignatoryAuthorityEmail.$reset()
    },
    onChangeSignatoryAuthority(selectedSignatoryAuthorityEmail){
              if (selectedSignatoryAuthorityEmail) {
                  const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.SignatoryAuthority.Name = selectedAuthority.text.replace(/ \(you\)$/, '').trim();;
                      this.SignatoryAuthority.Email = selectedAuthority.id;
                      this.SignatoryAuthority.Title = selectedAuthority.title;
                      this.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.SignatoryAuthority.Role = selectedAuthority.Role;
                      this.SignatoryAuthority.Id = selectedAuthority.SAId;
                    }
              }
            },
      getSignatoryauthorityList()
      {             
          this.showSignatoryauthorityList = false
            this.$loading({loadingText: 'Please wait..'});
              ajax.get(`/I983/SignatoryList?employeeId=${this.content.Employee.EmployeeId}`,{},(res)=>{
              this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
                var name = t.BasicModel.Name;
                        if(t.Email == this.loggedInUserObj.email)
                        {
                          name = t.BasicModel.Name + " (you)";
                        }
                        return { 'id': t.Email, 'text': name, "title":t.Designation , "phone":t.Phone ,"Role":t.Role,"SAId":t.Id}
              })
              if(this.content.AssignedTraining.SignatoryAuthority != null){
                  // this.selectedSignatoryAuthorityEmail = this.content.Employer.SignatoryAuthority.Email;
              } else {
                  this.selectedSignatoryAuthorityEmail = this.StudentDetails.SignatoryAuthority.Email;
              }

              this.showSignatoryauthorityList = true

              this.$loading({ "loadingText": "Please wait.." }).close()
          })
      },
    changeAuthority() {
      this.$v.selectedSignatoryAuthorityEmail.$touch()
      this.$loading({loadingText: 'Please wait..'});
      if(this.$v.selectedSignatoryAuthorityEmail.$invalid == false){
        ajax.put(`I983/UpdateSignatoryAuthority?id=${this.content.Id}&sectionType=${this.changeSAType}`,this.SignatoryAuthority, (res) => {
          if(res.data.State) {
            this.$message({
              type: "success",
              message: "Signatory Authority change successfully"
            }); 
            this.$parent.$parent.$parent.fetchData()
            this.$loading({loadingText: 'Please wait..'});
            this.close();
          }
          this.$loading().close();
        })
      }
    }
  }
};
</script>

<style scoped>
.current-authority {
display: flex;
justify-content: space-between;
padding-bottom: 20px;
/* border-bottom: 1px solid #ccc; */
}

.current-authority > div {
flex: 1;
padding-right: 10px;
}

.new-authority {
padding-top: 20px;
}

.note {
font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/ChangeSignAuth.vue